<template>
  <span>
    <v-btn @click="handleShowForm">
      Mark as paid
    </v-btn>

    <v-dialog v-model="showModal" max-width="800" persistent>
      <v-card>
        <v-card-title class="headline">Mark invoice as Paid</v-card-title>

        <v-card-text>
          <v-form v-model="isValid" ref="form">
            <v-textarea v-model="form.comment"/>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="handleHideForm">Cancel</v-btn>
          <v-btn @click="handleFormSubmit"
                 :disabled="!isSubmitEnabled"
                 :loading="requestInProgress">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
  import {mapActions} from "vuex";
  import {notificationService} from "../../../../application";
  import {InvoiceStatus} from "../../../../services/invoice";

  function getDefaultFormData() {
    return {
      comment: null,
    }
  }

  export default {
    name: 'mark-invoice-as-paid-form',
    props: {
      invoice: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        showModal: false,
        isValid: true,
        form: getDefaultFormData(),
        requestInProgress: false,
      }
    },
    watch: {
      showModal() {
        if (!this.showModal) {
          this.resetForm()
        }
      }
    },
    computed: {
      isSubmitEnabled() {
        const valid = this.isValid && !this.requestInProgress;
        if (!valid) {
          return false
        }
        if (this.$refs.form && !this.$refs.form.validate()) {
          return false
        }

        return true
      }
    },
    methods: {
      ...mapActions({
        changeInvoiceStatus: 'invoiceChangeInvoiceStatus',
      }),
      handleShowForm() {
        this.showModal = true
      },
      handleHideForm() {
        this.showModal = false
      },
      handleFormSubmit() {
        if (!this.isSubmitEnabled) {
          return
        }

        const request = {
          invoiceId: this.invoice.id,
          newStatus: InvoiceStatus.Paid,
          comment: this.form.comment,
        };

        this
          .changeInvoiceStatus(request)
          .then(() => {
            this.requestInProgress = false;
            notificationService.info('Operation success');
            this.resetForm();
            this.showModal = false
          })
          .catch(e => {
            this.requestInProgress = false;
            notificationService.error('Operation failed');
            throw e
          });

        this.requestInProgress = true;
      },
      resetForm() {
        this.form = getDefaultFormData()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/analytics/invoices/status/MarkInvoiceAsPaidForm.vue